import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DateTime } from 'luxon';
import { DurchfuehrungsTag, Product } from './Product.js';

/**
 * @entity ProductOGT
 */
@Entity()
export class ProductOGT extends Product {
  public static override _class = 'ProductOGT';
  @Field(() => Int)
  public OSLernFoerderung: Maybe<number>;

  @Field(() => Int)
  public USLernFoerderung: Maybe<number>;

  @Field(() => Int)
  public leFoeProWoche: Maybe<number>;

  @Field(() => Int)
  public leFoeDauer: Maybe<number>;

  @Field(() => DateTime)
  public archiveV1After: Maybe<DateTime>;

  @Field(() => Boolean)
  public useV2Courses: Maybe<boolean>;

  @Field(() => [DurchfuehrungsTag], { default: v => v ?? [] })
  public durchfuehrungsTage!: DurchfuehrungsTag[];

  initDefault() {
    this.leFoeProWoche = 2;
    this.leFoeDauer = 90;
    this.OSLernFoerderung = 6;
    this.USLernFoerderung = 12;
  }
}
